import { memo } from 'react';

/**
 * As a quick workaround to the virtualization issue with the sidebar, we're removing the `Box`
 * around all sections and rendering the list directly in the scrollable area. As a result,
 * we need to have a similar functionality to 'gap' to ensure that sections are spaced
 * out properly.
 */
export const WorkspaceSidebarSectionSpacer = memo(() => {
  return <div className="h-2 shrink-0 last:hidden" />;
});

WorkspaceSidebarSectionSpacer.displayName = 'WorkspaceSidebarSectionSpacer';
